import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import { StyledBox, StyledStack, StyledVpIcon, StyledTooltip } from './styles';

export const VpHoverInfo = ({
  title,
  titleProps,
  icon,
  iconProps,
  label = '',
  disablePointer = false,
  disableInteractive = true,
  isCard = false,
  children,
  fullWidth = false,
  disableFlex = false,
  ...rest
}) => {
  const tooltip = (
    <StyledTooltip
      isCard={isCard}
      title={label}
      disableInteractive={disableInteractive && !isCard}
      {...rest}
    >
      <StyledBox fullWidth={fullWidth} disablePointer={disablePointer} disableFlex={disableFlex}>
        {icon && <StyledVpIcon icon={icon} {...iconProps} />}
        {children}
      </StyledBox>
    </StyledTooltip>
  );

  if (!title) {
    return tooltip;
  }
  return (
    <StyledStack fullWidth={fullWidth} disableFlex={disableFlex}>
      {title && (
        <Typography variant="dropDownText" sx={{ whiteSpace: 'noWrap' }} {...titleProps}>
          {title}
        </Typography>
      )}
      {tooltip}
    </StyledStack>
  );
};
VpHoverInfo.propTypes = {
  title: PropTypes.string,
  titleProps: PropTypes.object,
  icon: PropTypes.string,
  iconProps: PropTypes.object,
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  disablePointer: PropTypes.bool,
  disableInteractive: PropTypes.bool,
  isCard: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disableFlex: PropTypes.bool
};

export default VpHoverInfo;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHoverInfo/VpHoverInfo.jsx